<template>
    <section class="content w-full flex flex-col pt-16 justify-center pb-10 text-chain">
        <div class="w-full border-y-2 border-carrot py-10">
            <div class="px-5 w-full md:w-3/4 mx-auto rounded">
                <section class="p-3 rounded flex flex-wrap md:flex-nowrap">
                    <div id="course-info" class="w-full md:w-4/5 px-2 pr-5">
                        <p class="text-4xl font-bold mb-10">
                            Carrinho de compras
                        </p>
                        <p class="font-bold border-b pb-2 border-iron">
                            {{ getCartQuantityNumber() }} {{ getCartQuantityText() }}
                        </p>
                        <div class="mt-3 flex flex-col gap-6">
                            <div v-for="(item, index) of cartItems" :key="index" class="flex shadow-lg py-2 px-4 md:h-48 flex-col md:flex-row">
                                <div class="w-auto mr-2 px-3 aspect-video">
                                    <img class="rounded mx-auto md:mx-0 my-auto h-full" :src="imageHandler.toBase64Img(item.coursePhoto)">
                                </div>
                                <div class="w-full md:w-3/6 px-3">
                                    <p class="text-sm text-left font-bold mb-3 break-normal">
                                        {{ item.title }}
                                    </p>
                                    <p class="text-sm text-left font-semibold text-chain">
                                        Por: {{ capitalizeWords(item.authorName) }}
                                    </p>
                                    <div class="mt-3 flex flex-col md:flex-row justify-between">
                                        <span><i class="pi pi-circle-fill" style="font-size: 0.5rem;"></i> {{ item.hours }} horas no total</span>
                                        <span><i class="pi pi-circle-fill" style="font-size: 0.5rem;"></i> {{ item.videosNumber }} aulas</span>
                                    </div>
                                    <div v-if="item.categories" class="mt-3 flex gap-2">
                                        <template v-for="(category, index) of item.categories" :key="index">
                                            <Tag v-if="index < 3" class="my-3">
                                                {{ ucfirst(category.getTranslatedName()) }}
                                            </Tag>
                                        </template>
                                    </div>
                                </div>
                                <div class="ml-auto text-right">
                                    <p class="text-carrot font-bold cursor-pointer p-2 rounded hover:opacity-75 border border-rounded" @click.prevent="removeFromCart(item)">
                                        REMOVER
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/5">
                        <div class="mx-auto text-center rounded md:mt-10 pt-10">
                            <p class="text-2xl font-bold mb-3 text-left">
                                Total
                            </p>
                            <p class="text-4xl font-bold text-lg text-left">
                                R${{ cartPrice }}
                            </p>
                            <Button
                                v-if="cartQuantity != 0"
                                label="Prosseguir"
                                class="bg-button w-full mb-2 mt-3"
                                @click.prevent="goToPaymentView()"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>
<script setup>
import { sleep } from '@/composables/sleep';
import { capitalizeWords, ucfirst } from '@/composables/textUtils';
import utils from '@/composables/utils';
import CourseService from '@/services/CourseService';
import store from '@/store';
import CartHandler from '@/store/handlers/CartHandler';
import { Button, Tag } from 'primevue';
import { computed, onMounted } from 'vue';
import imageHandler from '@/composables/handlers/ImageHandler';
import urlHandler from '@/composables/urlHandler';

const cartItems = computed(() => store.state.cart.items);
const cartQuantity = computed(() => store.state.cart.totalQuantity);
const cartPrice = computed(() => store.state.cart.totalPrice);

onMounted(() => {
    gatherCourseStatistics();
})

/**
 * Gather course statistics from cart items 
 */
async function gatherCourseStatistics() {
    await sleep(200);

    for (let course of cartItems.value) {
        let courseWithStatistics = store.getters.getOnDataChest(`course_statistics_${course.uuid}`);
        if(utils.isEmpty(courseWithStatistics)){
            const result = await CourseService.getStatistics(course.uuid);

            store.dispatch('saveOnDataChest', {
                key: `course_statistics_${course.uuid}`,
                value: result.getContent()
            });

            courseWithStatistics = result.getContent();
        }

        const cartHandler = new CartHandler({item: courseWithStatistics});
        store.dispatch('cart/updateCartItem', cartHandler);
    }
}

/**
 * Gets the cart quantity
 * @returns {Integer}
 */
function getCartQuantityNumber() {
    return !Number.isNaN(cartQuantity.value) ? cartQuantity.value : 0;
}

/**
 * Gets the translated text accordingly to cart quantity
 * @returns {String}
 */
function getCartQuantityText() {
    return cartQuantity.value == 1 ? 'curso no carrinho' : 'cursos no carrinho'
}

/**
 * Remove item from cart
 * @param {Object} item
 */
async function removeFromCart(item = {}) {

    const cartHandler = new CartHandler({item: item, persist: true});
    store.dispatch('cart/removeFromCart', cartHandler);
    
}

/**
 * Redirects to PaymentView
 */
async function goToPaymentView() {
    store.dispatch('savePurchaseItems', cartItems.value);
    urlHandler.redirectAndScroll('/purchase');
}

</script>